import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styled from "styled-components";
const Overlay = styled.div.withConfig({
  displayName: "Popup__Overlay",
  componentId: "sc-1ngzdb-0"
})(["position:fixed;left:0;right:0;top:0;bottom:0;background-color:rgba(0,0,0,0.5);"]);
export const CenterContainer = styled.div.withConfig({
  displayName: "Popup__CenterContainer",
  componentId: "sc-1ngzdb-1"
})(["position:absolute;left:0;right:0;top:0;bottom:0;display:flex;align-items:center;justify-content:center;"]);
const PopupContainer = styled.div.withConfig({
  displayName: "Popup__PopupContainer",
  componentId: "sc-1ngzdb-2"
})(["position:fixed;border:3px solid black;background:white;padding:1.3em;"]);
const Content = styled.div.withConfig({
  displayName: "Popup__Content",
  componentId: "sc-1ngzdb-3"
})(["overflow-y:auto;height:100%;max-height:calc(100vh - 5em);"]);
const ExitButtonContainer = styled.div.withConfig({
  displayName: "Popup__ExitButtonContainer",
  componentId: "sc-1ngzdb-4"
})(["position:absolute;top:0;right:0.2em;"]);
export const PopupHeadline = styled.h1.withConfig({
  displayName: "Popup__PopupHeadline",
  componentId: "sc-1ngzdb-5"
})(["margin-top:0;"]);
export const Popup = ({
  zIndex,
  closePopup,
  children,
  windowStyle
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Overlay, {
    onClick: closePopup,
    style: {
      zIndex
    }
  }), /*#__PURE__*/React.createElement(CenterContainer, null, /*#__PURE__*/React.createElement(PopupContainer, {
    style: _objectSpread({
      zIndex: zIndex + 1
    }, windowStyle)
  }, /*#__PURE__*/React.createElement(ExitButtonContainer, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faTimes,
    onClick: closePopup,
    size: "2x"
  })), /*#__PURE__*/React.createElement(Content, null, children))));
};